import { createStore } from 'vuex'
import ReactivePromiseStatus from "reactive-promise-status/dist/reactive-promise-status";
import {Api} from "@/api";

// Create a new store instance.
export const store = createStore({
    state () {
        return {
            user: new ReactivePromiseStatus(),
        }
    },
    mutations: {
        setUserPromise(state, data) {
            state.user.promise = data
        }
    },
    actions:{
        checkLogin({commit}){
            console.log('checkLogin')
            Api.__config.headers['x-token']=localStorage.getItem('token')
            commit('setUserPromise', Api.account.getCurrentUserInfo())
        },
        logout({commit}){
            console.log('logout')
            Api.account.logout();
            commit('setUserPromise', Promise.reject())

            window.gtag('event','logout', {})
        }
    }
})
